document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname == "/account") {
    setTimeout(() => {
      if (
        localStorage.getItem("isLoggedIn") !== undefined &&
        localStorage.getItem("isLoggedIn")
      ) {
        isLoggedIn = localStorage.getItem("isLoggedIn");
        localStorage.removeItem("isLoggedIn");
        if (isLoggedIn === "true") {
          window.location.href = "/collections/all";
        }
      }
    }, 1000);
  }

  const isLoggedIn = Boolean(window.__customer?.isLoggedIn);
  if (isLoggedIn) {
    console.log("El usuario está logueado...");
    document.addEventListener("shopify:cart:update", () => {
  console.log("El carrito se ha actualizado mediante un evento de Shopify");
  procesarPrecios(); // Llama a tu método aquí
});


(function () {
  const endpointsCarrito = /\/cart\/(add|change|update|clear)\.js|\/cart\.js/;

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
    const promesa = originalFetch.apply(this, args);
    if (endpointsCarrito.test(url)) {
      promesa.then(() => setTimeout(procesarPrecios, 400));
    }
    return promesa;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (endpointsCarrito.test(url)) {
      this.addEventListener("loadend", () => setTimeout(procesarPrecios, 400));
    }
    return originalOpen.apply(this, arguments);
  };
})();
    
    setTimeout(() => {
      procesarPrecios(); // Ejecutar tu función después de un breve retardo
    }, 500); // Ajusta el retardo si es necesario

    // Detectar clic en el botón del carrito
    const cartButtons = document.querySelectorAll(".product-form__submit");

    if (cartButtons.length > 0) {
      console.log("Detecta carritos");

      cartButtons.forEach((cartButton) => {
        cartButton.addEventListener("click", function () {
          // Usar un retardo para dar tiempo al drawer de abrirse
          console.log("Clic en agregar en un botón");
          setTimeout(procesarPrecios, 1000); // Ajusta el tiempo según sea necesario
        });
      });
    } else {
      console.log("NO Detecta ningún carrito");
    }

    if (window.location.href.includes("/cart")) {
      const observerCartPage = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          console.log("Cambios detectados en carrito");
          setTimeout(() => {
            procesarPrecios(); // Ejecutar tu función después de un breve retardo
          }, 500); // Ajusta el retardo si es necesario
        });
      });

      const targetNodeCart = document.querySelector(".cart-items");
      observerCartPage.observe(targetNodeCart, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    const observerCart = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        console.log("Cambios detectados en carrito");
        setTimeout(() => {
          procesarPrecios(); // Ejecutar tu función después de un breve retardo
        }, 500); // Ajusta el retardo si es necesario
      });
    });

    const targetNode = document.getElementById("CartDrawer");
    observerCart.observe(targetNode, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    const productContainer = document.getElementById("ProductGridContainer");
    if (!productContainer) {
      console.warn(
        "No se encontró el contenedor con id #ProductGridContainer."
      );
    } else {
      console.log("Se encontró el contenedor de productos:", productContainer);
    }

    if (productContainer) {
      const observerProduct = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          // Detectar si hay nodos añadidos o eliminados
          if (
            mutation.addedNodes.length > 0 ||
            mutation.removedNodes.length > 0
          ) {
            console.log("Cambios detectados en el contenedor de productos.");
            setTimeout(() => {
              procesarPrecios(); // Ejecutar tu función después de un breve retardo
            }, 500); // Ajusta el retardo si es necesario
          }
        });
      });

      // Configuración del observador para observar cambios en hijos y descendientes
      const config = { childList: true, subtree: true, characterData: true }; // Observa los cambios en los hijos y subárbol
      observerProduct.observe(productContainer, config);

      console.log(
        "Observador de mutaciones configurado para #ProductGridContainer."
      );
    } else {
      console.warn(
        "No se encontró el contenedor con id #ProductGridContainer."
      );
    }

    document.getElementById("userbtntop_acc").style.display = "none";
    document.getElementById("userbtntop_ing").style.display = "block";

    // Crear el botón de Preguntas Frecuentes
    var faqButton = document.createElement("a");
    faqButton.href = "/pages/preguntas-frecuentes";
    faqButton.innerText = "Preguntas Frecuentes";
    faqButton.target = "_self";
    faqButton.id = "faq-link";
    faqButton.style.position = "fixed";
    faqButton.style.bottom = "80px"; // Ajusta para que aparezca encima del botón de WhatsApp
    faqButton.style.right = "20px";
    faqButton.style.backgroundColor = "#000000";
    faqButton.style.color = "#FFFFFF";
    faqButton.style.borderRadius = "5px";
    faqButton.style.width = "auto";
    faqButton.style.height = "50px";
    faqButton.style.display = "flex";
    faqButton.style.alignItems = "center";
    faqButton.style.justifyContent = "center";
    faqButton.style.boxShadow = "2px 2px 3px rgba(0,0,0,0.3)";
    faqButton.style.zIndex = "999"; // Un poco menor para que esté justo encima del de WhatsApp
    faqButton.style.padding = "10px 20px"; // Añade padding para el texto

    // Añadir el botón de Preguntas Frecuentes al cuerpo del documento
    document.body.appendChild(faqButton);

    // Función para ocultar el botón de Preguntas Frecuentes después de 3 segundos
    setTimeout(function () {
      faqButton.style.display = "none";
    }, 3000); // 3000 milisegundos = 3 segundos
  } else {

    /*
    console.log("El usuario no está logueado");

    var popupLogCount = sessionStorage.getItem("popupLogCount") || 0;

    if (
      window.location.href.includes("collections/all") &&
      popupLogCount == 0
    ) {
      sessionStorage.setItem("popupLogCount", ++popupLogCount);
      console.log("En accesorios sin logueo");
      // Crear el botón de Preguntas Frecuentes
      var logButton = document.createElement("a");
      logButton.href = "/account/login";
      logButton.innerHTML =
        "¿Buscas precios mayoristas?<br><strong>Inicia sesión aquí</strong>"; // Usar HTML para formato
      logButton.target = "_self";
      logButton.id = "log-link";

      // Estilos del botón
      logButton.style.position = "fixed";
      logButton.style.bottom = "150px"; // Ajusta para que aparezca encima del botón de WhatsApp
      logButton.style.right = "20px";
      logButton.style.backgroundColor = "#aa4e91"; // Color azul llamativo
      logButton.style.color = "#FFFFFF"; // Texto blanco
      logButton.style.borderRadius = "10px"; // Esquinas más redondeadas
      logButton.style.display = "flex";
      logButton.style.flexDirection = "column"; // Organiza texto en columnas
      logButton.style.alignItems = "center";
      logButton.style.justifyContent = "center";
      logButton.style.width = "auto";
      logButton.style.minWidth = "180px"; // Mínimo ancho para buena visibilidad
      logButton.style.height = "auto"; // Altura ajustada
      logButton.style.padding = "15px 25px"; // Más espacio interno
      logButton.style.fontFamily = "Arial, sans-serif"; // Fuente más moderna
      logButton.style.fontSize = "16px"; // Tamaño legible
      logButton.style.textAlign = "center"; // Centra el texto
      logButton.style.lineHeight = "1.5"; // Mejor separación entre líneas
      logButton.style.textDecoration = "none"; // Quita subrayado del enlace
      logButton.style.boxShadow = "4px 4px 10px rgba(0, 0, 0, 0.2)"; // Sombra suave
      logButton.style.transition = "transform 0.3s ease, box-shadow 0.3s ease"; // Animación al hover
      logButton.style.zIndex = "999";

      // Efecto hover
      logButton.onmouseover = function () {
        logButton.style.transform = "scale(1.1)"; // Aumenta tamaño al pasar el cursor
        logButton.style.boxShadow = "6px 6px 15px rgba(0, 0, 0, 0.3)"; // Sombra más intensa
      };
      logButton.onmouseout = function () {
        logButton.style.transform = "scale(1)"; // Restaura tamaño
        logButton.style.boxShadow = "4px 4px 10px rgba(0, 0, 0, 0.2)"; // Restaura sombra
      };

      // Agrega el botón al documento
      document.body.appendChild(logButton);

      // Función para ocultar el botón de Preguntas Frecuentes después de 3 segundos
      setTimeout(function () {
        logButton.style.display = "none";
      }, 10000); // 3000 milisegundos = 3 segundos
    }

    document.getElementById("userbtntop_ing").style.display = "none";
    document.getElementById("userbtntop_acc").style.display = "block";

    return;
    */
  }
});

// Función para procesar los precios + Cris
function procesarPrecios() {
  const precios = document.querySelectorAll(
    ".price-item.price-item--regular, .cart-item__final-price, .cart-item__price-wrapper .price"
  );

  precios.forEach(function (precio) {
    const textoActual = precio.textContent.trim();

    if (precio.dataset.discountSource === textoActual) return;

    const hermano = precio.nextElementSibling;
    if (hermano && hermano.classList.contains("precio-descuento-wrapper")) {
      hermano.remove();
    }

    // Elimina todo lo que no sea dígito (símbolo $, puntos, comas, espacios)
    let precioNumerico = parseFloat(textoActual.replace(/[^\d]/g, ""));

    let precioMitad = precioNumerico * obtenerMultiplicadorDescuento();

    if (!isNaN(precioMitad)) {
      let precioMitadFormateado = `$${precioMitad.toLocaleString("es-CO", {
        minimumFractionDigits: 0,
      })}`;

      let nuevoPrecio = document.createElement("div");
      nuevoPrecio.classList.add("precio-descuento-wrapper");

      let precioOriginal = document.createElement("div");
      let precioMitadDiv = document.createElement("div");
      precioOriginal.innerHTML = `<s class='lowprice'>${precio.innerHTML}</s>`;
      precioMitadDiv.innerHTML = `${precioMitadFormateado}`;

      nuevoPrecio.appendChild(precioOriginal);
      nuevoPrecio.appendChild(precioMitadDiv);

      precio.parentNode.insertBefore(nuevoPrecio, precio.nextSibling);
      precio.style.display = "none";

      precio.dataset.discountSource = textoActual;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  var whatsappButton = document.createElement("a");
  whatsappButton.href = "https://api.whatsapp.com/send?phone=573012992461";
  whatsappButton.target = "_blank";
  whatsappButton.id = "whatsapp-link";
  whatsappButton.style.position = "fixed";
  whatsappButton.style.bottom = "150px";
  whatsappButton.style.right = "20px";
  whatsappButton.style.backgroundColor = "#573520";
  whatsappButton.style.borderRadius = "50%";
  whatsappButton.style.width = "50px";
  whatsappButton.style.height = "50px";
  whatsappButton.style.display = "flex";
  whatsappButton.style.alignItems = "center";
  whatsappButton.style.justifyContent = "center";
  whatsappButton.style.boxShadow = "2px 2px 3px rgba(0,0,0,0.3)";
  whatsappButton.style.zIndex = "1000";
  whatsappButton.style.padding = "10px";

  var whatsappIcon = new Image();
  whatsappIcon.src =
    "https://cdn.shopify.com/s/files/1/0634/4002/7805/files/whatsapp-icon-509x512-c9csi2fs_480x480.png";
  whatsappIcon.alt = "WhatsApp";
  whatsappIcon.style.width = "100%";
  whatsappIcon.style.height = "auto";
  whatsappIcon.style.display = "block";

  whatsappButton.appendChild(whatsappIcon);
  document.body.appendChild(whatsappButton);
});

document.addEventListener("DOMContentLoaded", function () {
  // Detecta si la URL actual contiene "/products/"
  if (window.location.href.includes("/products/")) {
    // Busca el elemento <h4> que contiene el texto "1 año de garantía sin condiciones"
    let garantiaElement = document.querySelector(
      "h4 img[src*='garantia_2.svg']"
    );

    if (garantiaElement && garantiaElement.parentElement) {
      let parentElement = garantiaElement.parentElement;

      // Verifica que el texto contenga "1 año de garantía sin condiciones"
      if (
        parentElement.innerText.includes("3 meses de garantía sin condiciones")
      ) {
        // Cambia el texto a "1 año de garantía"
        parentElement.innerHTML =
          '<img class="alignnone size-full wp-image-151062" role="img" src="https://cdn.shopify.com/s/files/1/0634/4002/7805/files/garantia_2.svg?v=1725385779" alt="" width="69" height="74">3 meses de garantía';
      }
    }
  }
});


function obtenerMultiplicadorDescuento() {
  const tags = (window.__customer?.tags || []).map(t => t.toLowerCase());
  if (tags.includes("cuarenta")) {
    return 0.6; // 40% de descuento (paga el 60%)
  }
  return 0.5; // 50% de descuento por defecto
}